import script from "./AddChannel.vue?vue&type=script&setup=true&lang=js"
export * from "./AddChannel.vue?vue&type=script&setup=true&lang=js"

import "./AddChannel.vue?vue&type=style&index=0&id=5ee7dc12&lang=scss"

const __exports__ = script;

export default __exports__